const DSML_BLOCK_RE = /<\|DSML\|tool_calls>[\s\S]*?<\/\|DSML\|tool_calls>/gi;
const DSML_TAG_RE = /<\|DSML\|[^>]*>/gi;

export function containsDsmlMarkup(text) {
  return typeof text === 'string' && /<\|DSML\|/i.test(text);
}

export function stripDsmlMarkup(text) {
  if (!text || typeof text !== 'string') return '';
  return text.replace(DSML_BLOCK_RE, '').replace(DSML_TAG_RE, '');
}

export function visibleChatText(content, reasoning) {
  const c = stripDsmlMarkup(content ?? '');
  const r = stripDsmlMarkup(reasoning ?? '');
  return { content: c, reasoning: r };
}
